import React, { useEffect, useRef } from 'react';
import styles from './AlertVisibility.module.scss';
import { Alert, Fade, Slide } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as BadgeCheck } from 'new/components/icons/fi-sr-badge-check.svg';
import { AlertData, hideAlert, SHOW_ALERT } from 'new/stores/showAlert/action';
import cx from 'classnames';

interface AlertVisibilityProps {}

export function AlertVisibility(props: AlertVisibilityProps) {
  const timeout = useRef<NodeJS.Timeout>(null);
  const dispatch = useDispatch();
  const { type, payload } = useSelector((state: any) => state.alertVisibility);
  const { title, severity = 'info', onClose } = (payload || {}) as AlertData;

  const onCloseAlert = () => {
    onClose?.();
    dispatch(hideAlert());
    clearTimeout(timeout.current);
  };

  useEffect(() => {
    if (type === SHOW_ALERT) {
      timeout.current = setTimeout(() => {
        dispatch(hideAlert());
        onClose?.();
      }, 3000);
    }
  }, [type]);

  return (
    <div className={[styles.container, type === SHOW_ALERT ? styles.containerIn : ''].join(' ')}>
      <Slide in={type === SHOW_ALERT} direction="left">
        <Fade in={type === SHOW_ALERT}>
          <Alert
            onClose={onCloseAlert}
            iconMapping={{
              success: <BadgeCheck />,
            }}
            severity={severity}
            className={cx(styles.alert, severity === 'success' ? styles.success : '')}
          >
            {title}
          </Alert>
        </Fade>
      </Slide>
    </div>
  );
}
